import { Tag } from '@wix/design-system'
import classNames from 'classnames'
import React, { ComponentProps, FC } from 'react'

import s from './WixMobileChip.scss'

type WixMobileChipProps = ComponentProps<typeof Tag>

export const WixMobileChip: FC<WixMobileChipProps> = ({ className, size = 'medium', removable = false, ...props }) => (
  <Tag {...props} size={size} removable={removable} className={classNames(s.chip, className)} />
)
